import SubscriptionPlanHero from './subscription-plan-hero';

export default SubscriptionPlanHero;
